import axios from "axios";
import { toast } from "react-toastify";

export const uploads = async (formData) => {
  try {
    const url = `/api/uploads`;
    const response = await axios.post(url, formData, {
      credentials: "include",
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data?.data;
  } catch (error) {
    toast.error(error?.response?.data?.message);
    throw error;
  }
};

export const uploadsS3 = async (formData) => {
  try {
    const url = `/api/uploads/s3`;
    const response = await axios.post(url, formData, {
      credentials: "include",
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data?.data;
  } catch (error) {
    toast.error(error?.response?.data?.message || "Failed to upload to S3");
    throw error;
  }
};

export const getS3Presign = async ({ filename, contentType, folderPath }) => {
  try {
    const url = `/api/uploads/s3/presign`;
    const response = await axios.post(url, { filename, contentType, folderPath }, {
      credentials: "include",
      headers: { "Content-Type": "application/json" },
    });
    return response.data?.data;
  } catch (error) {
    toast.error(error?.response?.data?.message || "Failed to create presigned URL");
    throw error;
  }
};
